/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../../Component/Interceptor/Interseptor'
import {message} from 'antd'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import Page from '../../Component/Pagination/Pagination'
import HeaderTable from '../BaseComponent/HeaderTable'
import $, {param} from 'jquery'
import cookie from 'react-cookies'
import jMoment from 'moment-jalaali'
import HeaderTablePrint from '../BaseComponent/HeaderTablePrint'
import {ExcelExport, ExcelExportColumn} from '@progress/kendo-react-excel-export'
import Sort from '../Pagination/Sort'
import HeaderGrid from '../Pagination/HeaderGrid'
import Pageing from '../Pagination/pageing'
import Loader from '../loaders/loader'
import FromToPicker from '../BaseComponent/FromToPicker'
import Select from 'react-select'
import CRM from '../BaseComponent/CRM'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import {accounting} from 'accounting'

import {orderInfo} from '../../lib/path'

class CallToBuy extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      printInfo: [],
      cars: [],
      pageNumber: 1,
      pageNumberDetail: 1,
      pageSize: 10,
      sortBy: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'نام',
          value: 'title',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تعداد تماس',
          value: 'callCount',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تعداد تماس منجر به خرید',
          value: 'buyCountCall',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'درصد تماس منجر به خرید',
          value: 'callToBuyPercent',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'جزییات',
          value: 'edit',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      items: [],
      fromTime: '',
      toTime: '',
      subjects: [],
      categories: [],
      subjectId: null,
      categoryId: null,
      operators: [],
      operatorId: null,
      details: [],
      detail: {},
      filter: {}
    }
  }

  createFilter = (exportStatus) => {
    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.sortBy = this.state.sortBy
    filter.export = exportStatus
    const daysAfterCall = document.getElementById('daysAfterCall').value
    let {fromTime, toTime, subjectId, categoryId, operatorId} = this.state

    if (fromTime) {
      filter.fromTime = fromTime
    }
    if (toTime) {
      filter.toTime = toTime
    }

    // if (subjectId) {
    //   filter.contactSubjectId = subjectId.value;
    // }
    // if (categoryId) {
    //   filter.contactCategoryId = categoryId.value;
    // }
    if (operatorId) {
      filter.operatorId = operatorId.value
    }
    if (daysAfterCall) {
      filter.daysAfterCall = daysAfterCall
    }

    return filter
  }
  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    this.setState({
      loading: true
    })
    http
      .get(`report/retail/call-to-buy/master`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          if (!exportStatus) {
            this.setState({
              items: response.data.object.result,
              countAll: response.data.object.countAll,
              loading: false,
              filter: response.data.data
            })
          } else {
            this.setState({
              printInfo: response.data.object.result,
              loading: false
            })
          }
        } else {
          this.setState({
            items: [],
            loading: false
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }

    if (prevState.pageSize !== this.state.pageSize) {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }
  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })
    // this.getCategories();
    // this.getOperators();
  }

  getSubjects = (contactCategoryId) => {
    return http
      .get(`${CRM.CRM_CONTACT_SUBJECT_LIST}`, {
        params: {
          contactCategoryId
        }
      })
      .then((res) => {
        if (res.data.error === null) {
          let subjects = res.data.object
          subjects.forEach((item) => {
            item.value = item.contactSubjectId
            item.label = item.contactSubjectName
          })
          this.setState({
            subjects
          })
        }
      })
      .catch((err) => {})
  }

  getCategories = () => {
    return http
      .get(`${CRM.CRM_CONTACT_CATEGORY_LIST}`, {})
      .then((res) => {
        if (res.data.error === null) {
          let categories = res.data.object
          categories.forEach((item) => {
            item.value = item.contactCategoryId
            item.label = item.contactCategoryName
          })
          this.setState({
            categories
          })
        }
      })
      .catch((err) => {})
  }

  getOperators = () => {
    return http.get(`${USER_MANAGE.USER_MANAGE_LIST_OPERATOR}`, {}).then((response) => {
      if (response.data.error === null) {
        var operators = response.data.object
        for (let i = 0; i < operators.length; i++) {
          operators[i]['value'] = operators[i].personId
          operators[i]['label'] = operators[i].personId + ' - ' + operators[i].name
        }
        this.setState({
          operators
        })
      }
    })
  }

  changeSubject = (subjectId) => {
    this.setState({subjectId})
  }

  changeCategory = (categoryId) => {
    this.setState({categoryId}, () => {
      if (this.state.categoryId !== null) {
        this.getSubjects(categoryId.value)
        this.setState({
          subjects: [],
          subjectId: null
        })
      } else {
        this.setState({
          subjects: [],
          subjectId: null
        })
      }
    })
  }

  changeOperator = (operatorId) => {
    this.setState({
      operatorId
    })
  }

  changeFromDate = (fromTime) => {
    this.setState({fromTime})
  }

  changeToDate = (toTime) => {
    this.setState({toTime})
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  filter() {
    let {fromTime, toTime, subjectId, categoryId} = this.state
    if (!fromTime) {
      message.error('فیلدهای ستاره دار وارد شود')
    } else {
      this.setState(
        {
          pageNumber: 1
        },
        () => {
          this.getReport(false)
        }
      )
    }
  }

  exportExcel = () => {
    let filter = this.createFilter(true)
    this.setState({
      loading: true
    })
    http
      .get(`report/retail/call-to-buy/master`, {
        params: filter
      })
      .then((response) => {
        this.setState({
          loading: false
        })
        if (response.data.error == null) {
          this.setState({
            excelReport: response.data.object.result
          })
          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        // alert(JSON.stringify(error))
      })
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 portrait;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  getPageSize = (pageSize) => {
    this.setState({
      pageSize
    })
  }
  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  changeFamily = (processId) => {
    this.setState({
      processId
    })
  }

  pageNumberDetail = (pageNumberDetail) => {
    this.setState({pageNumberDetail}, () => {
      this.showDetails(this.state.detail)
    })
  }

  showDetails = (item) => {
    let params = this.state.filter
    delete params.sortBy
    delete params.contactSubjectId
    delete params.contactCategoryId

    params.pageNumber = this.state.pageNumberDetail
    params.operatorId = item.operatorId
    this.setState({
      loading: true,
      operatorName: item.firstName + ' ' + item.lastName,
      detail: item
    })
    return http
      .get(`report/retail/call-to-buy/detail`, {
        params
      })
      .then((res) => {
        this.setState({
          loading: false
        })
        if (res.data.error === null) {
          this.setState({
            details: res.data.object.result,
            detailsModal: true,
            countAllDetail: res.data.object.countAll
          })
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  render() {
    let {pageNumber, pageSize, loading} = this.state

    let printCol = ['ردیف', 'نام', 'تعداد تماس', 'تعداد تماس منجر به خرید', 'درصد تماس منجر به خرید']
    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />
        <div className="printSection">
          <table className="printTable printReportTable" ref={(node) => (this.printPart = node)}>
            <HeaderTablePrint
              header="گزارش درصد موفقیت تماس اپراتورها"
              headerColSpan={5}
              reporter={cookie.load('name')}
              timePrint={jMoment().format('jYYYY/jM/jD HH:mm')}
              leftColSpan={3}
              rightColSpan={1}
              centerColSpan={1}
              centerSection={''}
              rightSection={''}
              columns={printCol}
            />

            <tbody>
              {this.state.printInfo.map((item, index) => (
                <tr key={'i' + index}>
                  <td>{index + 1}</td>
                  <td>{item.firstName + ' ' + item.lastName}</td>
                  <td>{item.callCount}</td>
                  <td>{item.buyCountCall}</td>
                  <td>{item.callToBuyPercent}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش درصد موفقیت تماس اپراتورها.xls"
          >
            <ExcelExportColumn
              key={'firstName'}
              field={'firstName'}
              title={'نام'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'lastName'}
              field={'lastName'}
              title={'نام خانوادگی'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />

            <ExcelExportColumn
              key={'callCount'}
              field={'callCount'}
              title={'تعداد تماس'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'buyCountCall'}
              field={'buyCountCall'}
              title={'تعداد تماس منجر به خرید'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
            <ExcelExportColumn
              key={'callToBuyPercent'}
              field={'callToBuyPercent'}
              title={'درصد تماس منجر به خرید'}
              footerCellOptions={{wrap: true, textAlign: 'center'}}
            />
          </ExcelExport>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>خرید و فروش</li>
            <li>گزارش درصد موفقیت تماس اپراتورها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <FromToPicker
                  onChangeFromDate={this.changeFromDate}
                  onChangeToDate={this.changeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  defaulValue
                  fromId="from"
                  toId="to"
                  forceStart
                />
                {/* <div className="formComponent">
                  <label>
                    خانواده تماس
                    <span className="text-danger mx-1">*</span>
                  </label>
                  <Select
                    value={this.state.categoryId}
                    onChange={this.changeCategory}
                    options={this.state.categories}
                    isClearable={true}
                    placeholder={""}
                  />
                </div>
                <div className="formComponent">
                  <label>
                    موضوع تماس
                    <span className="text-danger mx-1">*</span>
                  </label>
                  <Select
                    value={this.state.subjectId}
                    onChange={this.changeSubject}
                    options={this.state.subjects}
                    isClearable={true}
                    placeholder={""}
                  />
                </div> */}
                {/* <div className="formComponent">
                  <label>اپراتور</label>
                  <Select
                    value={this.state.operatorId}
                    onChange={this.changeOperator}
                    options={this.state.operators}
                    isClearable={true}
                    placeholder={""}
                  />
                </div> */}
                <div className="formComponent">
                  <label>تعداد روز تماس منجر به خرید</label>
                  <input type="number" className="form-control" id="daysAfterCall" />
                </div>
              </div>

              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>
            {this.state.items.length > 0 ? (
              <div className="showBaseTable">
                <table className="baseTable">
                  <Sort data={this.state.sortData} getSort={this.getSort} />
                  <tbody>
                    {this.state.items.map((item, index) => (
                      <tr key={index}>
                        <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                        <td>{item.firstName + ' ' + item.lastName}</td>
                        <td>{item.callCount}</td>
                        <td>{item.buyCountCall}</td>
                        <td>{item.callToBuyPercent}</td>
                        <td>
                          <button onClick={() => this.showDetails(item)} className="bg-transparent border-0">
                            <img src={require('../../image/details.svg')} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="paginationWrapp">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumber}
                    pageSize={this.state.pageSize}
                    currentPage={this.state.pageNumber}
                    total={this.state.countAll}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <Modal
          isOpen={this.state.detailsModal}
          toggle={() => this.setState({detailsModal: false, pageNumberDetail: 1})}
          size="lg"
        >
          <ModalHeader>
            <div>{'تماس های اپراتور :‌ ' + this.state.operatorName}</div>
          </ModalHeader>
          <ModalBody className="pb-1">
            <table className="table mb-0 table-bordered table-striped">
              <tr className="bg-light">
                <td>ردیف</td>
                <td>نام مشتری</td>
                <td>تاریخ ثبت سفارش</td>
                <td>شناسه سفارش</td>
                <td>مبلغ سفارش</td>
              </tr>
              {this.state.details.map((item, index) => (
                <tr>
                  <td>{(this.state.pageNumberDetail - 1) * 10 + index + 1}</td>
                  <td>{item.fullName}</td>
                  <td>{jMoment(item.orderCreated).format('jYYYY/jMM/jDD HH:mm')}</td>
                  <td>
                    <a target="_blank" className="text-blue text-primary" href={orderInfo({orderId: item.orderId})}>
                      {item.orderId}
                    </a>
                  </td>
                  <td>{accounting.formatMoney(item.payable, '', ',')}</td>
                </tr>
              ))}
            </table>
            <div className="paginationWrapp">
              <Pageing
                defaultCurrent={1}
                getPage={this.pageNumberDetail}
                pageSize={10}
                currentPage={this.state.pageNumberDetail}
                total={this.state.countAllDetail}
              />
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default CallToBuy
